module.exports = __webpack_public_path__ + "img/logo-ant.15fdda66.svg";